export default __webpack_public_path__ + "static/media/gallery_05.5f378e0f.jpg";